import {
  DistributionChannel,
  DistributionChannelTypeEnum,
} from '../../../api/queries';

/** The human readable destination of a channel: Slack/Teams channel name, or the address. */
export const getChannelDisplayValue = (channel: DistributionChannel): string => {
  if (channel.type === DistributionChannelTypeEnum.Slack && channel.slackChannelName) {
    return `#${channel.slackChannelName}`;
  }
  if (
    channel.type === DistributionChannelTypeEnum.MicrosoftTeams &&
    channel.teamsChannelName
  ) {
    return channel.teamsChannelName;
  }
  return channel.webhookUrl || '–';
};
